import type { Composer } from 'vue-i18n';

import { LoadState } from '@/stores/types';

export function isSuccessfulEmptyAgentResults(loadState: LoadState, count: number): boolean {
  return loadState === LoadState.LOADED && count === 0;
}

export function getAgentDirectoryPageTitle(
  t: Composer['t'],
  {
    currentPage,
    locationLabel,
    count,
    hasSearchedLocations,
    isSuccessfulEmpty,
  }: {
    currentPage: number;
    locationLabel: string;
    count: number;
    hasSearchedLocations: boolean;
    isSuccessfulEmpty: boolean;
  },
): string {
  if (currentPage > 1) {
    return isSuccessfulEmpty
      ? t('seo.agentEmptyResultsPageTitleWithPageLocationSpecific', {
          page: currentPage,
          location: locationLabel,
        }).toString()
      : t('seo.agentPageTitleWithPageLocationSpecific', {
          page: currentPage,
          location: locationLabel,
          count,
        }).toString();
  }

  if (hasSearchedLocations) {
    return isSuccessfulEmpty
      ? t('seo.agentEmptyResultsPageTitleLocationSpecific', {
          location: locationLabel,
        }).toString()
      : t('seo.agentPageTitleLocationSpecific', {
          location: locationLabel,
          count,
        }).toString();
  }

  return t('seo.agentPageTitleNational').toString();
}

export function getAgentDirectoryPageDescription(
  t: Composer['t'],
  {
    locationLabel,
    count,
    hasSearchedLocations,
    isSuccessfulEmpty,
  }: {
    locationLabel: string;
    count: number;
    hasSearchedLocations: boolean;
    isSuccessfulEmpty: boolean;
  },
): string {
  if (!hasSearchedLocations) {
    return t('seo.agentPageDescriptionNational').toString();
  }

  return isSuccessfulEmpty
    ? t('seo.agentEmptyResultsPageDescriptionLocationSpecific', {
        location: locationLabel,
      }).toString()
    : t('seo.agentPageDescriptionLocationSpecific', {
        location: locationLabel,
        count,
      }).toString();
}
